import Paperclip from "@/Icons/Paperclip";
import { useConfig } from "@/api/hooks/useConfig";
import { Button } from "@/components/button";
import { useTrans } from "@/translations";

import React, { useContext } from "react";

import { ImportContext } from "../ImportContext";

export const DownloadTemplates: React.FC = () => {
  const { t } = useTrans();
  const { templates } = useContext(ImportContext);
  const { isMWM, config } = useConfig();

  return (
    <div className="border-grey3 w-2/3 border">
      {templates.map((template) => (
        <div
          key={template.key}
          className="border-grey3 relative flex items-center justify-between border-b p-4 last:border-b-0"
        >
          <div className="flex items-center">
            <Paperclip />
            <div className="ml-2">{t(template.title)}.xlsx</div>
          </div>
          <Button
            label="importLabels:download"
            onClick={() =>
              template.downloadFile(
                template.title,
                isMWM,
                !!config.useWasteSuctionSystem,
              )
            }
            type="button"
            color="primary"
          />
        </div>
      ))}
    </div>
  );
};
